// src/api/api.js
// ✅ استخدام مسار نسبي ليعمل تلقائياً مع الدومين الحالي والبروكسي
const API_BASE = process.env.REACT_APP_API_BASE || "/api";

/**
 * طلب موحّد للتعامل مع JSON و أخطاء API
 */
async function request(path, options = {}) {
  const url = `${API_BASE}${path}`;

  const {
    method = "GET",
    body,
    headers = {},
    raw = false,
  } = options;

  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

  // إعداد الهيدرز
  const reqHeaders = { ...headers };
  
  // إضافة Content-Type إذا لم يكن FormData
  if (!isFormData) {
    reqHeaders["Content-Type"] = "application/json";
  }

  // ✅ حقن التوكن تلقائياً من localStorage
  const token = localStorage.getItem("token");
  if (token) {
    reqHeaders["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    method,
    headers: reqHeaders,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  if (raw) return res;

  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  let data = null;
  try {
    data = isJson ? await res.json() : await res.text();
  } catch (_) {
    data = null;
  }

  if (!res.ok) {
    // ✅ معالجة تسجيل الخروج القسري (كما هو مستخدم في App.js)
    if (res.status === 401 && data?.error === "SESSION_REPLACED") {
      window.dispatchEvent(new CustomEvent("auth:forcedLogout", { detail: data.message }));
    }

    const msg = (data && data.message) || (typeof data === "string" && data) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: "POST", body }),
  put: (path, body) => request(path, { method: "PUT", body }),
  del: (path) => request(path, { method: "DELETE" }),
  auth: {
    login: (username, password) => {
      const body = typeof username === "string" ? { username, password } : username;
      return request("/auth/login", { method: "POST", body });
    },
    me: () => request("/auth/me"),
    logout: () => request("/auth/logout", { method: "POST" }),
    clear: () => {
      localStorage.removeItem("token");
      localStorage.removeItem("permissions");
    },
  }
};